import { getJSON } from 'common/services/api'
import { useQuery } from 'react-query'

export const useGoalsStats = () => {
  const GET_GOALS_STATS = `/api/aggregations/goals-stats`

  const { data, isLoading } = useQuery(
    ['goals-stats'],
    () =>
      getJSON({
        url: GET_GOALS_STATS,
      }),
    { enabled: true }
  )

  return { data: data?.data || null, isLoading }
}
